export default "__VITE_ASSET__CFrOsPqA__"